import { trackEvent } from '~/features/analytics/track-event';
import type { ExperienceAtfPromoVariant } from '~/features/experience/constants';
import { SitewideSaleBanner } from '~/features/promotions/components/sitewide-sale-banner';
import { SitewideSalePromoCard } from '~/features/promotions/components/sitewide-sale-promo-card';
import {
  type Summer2026SaleVariant,
  getSummer2026SaleCheckoutHref,
  SUMMER_2026_SALE_CTA_LABEL,
  SUMMER_2026_SALE_VARIANTS,
} from '~/features/promotions/constants/summer-2026-sale';

import type { PromoCampaignSurfaceRenderers } from '../types';

const SUMMER_2026_SALE_ATF_PROMO_VARIANT: Record<Summer2026SaleVariant, ExperienceAtfPromoVariant> = {
  july_4th: 'july_4th_sale',
  summer: 'summer_sale',
  mid_year_sale: 'summer_sale',
};

export const summer2026CampaignSurfaces: PromoCampaignSurfaceRenderers<Summer2026SaleVariant>['surfaces'] = {
  homepage: ({ resolved, promoCode, imagePriority, onClick }) => (
    <SitewideSalePromoCard
      imagePriority={imagePriority}
      promoCode={promoCode}
      variant={resolved}
      onClick={
        onClick ??
        (() =>
          trackEvent({
            type: 'click',
            name: 'Homepage CTA Clicked',
            label: 'summer_2026_sale_clicked',
          }))
      }
    />
  ),
  catalog: ({ resolved, promoCode, imagePriority, onCtaClick }) => (
    <SitewideSaleBanner
      imagePriority={imagePriority}
      promoCode={promoCode}
      variant={resolved}
      onCtaClick={
        onCtaClick ??
        (() =>
          trackEvent({
            type: 'click',
            name: 'Catalog Page CTA Clicked',
            label: 'summer_2026_sale_clicked',
          }))
      }
    />
  ),
  experience: ({ resolved, promoCode }) => {
    const config = SUMMER_2026_SALE_VARIANTS[resolved];
    const promoVariant = SUMMER_2026_SALE_ATF_PROMO_VARIANT[resolved];

    return {
      id: promoVariant,
      promoVariant,
      eyebrow: 'Ends soon',
      title: config.headlineLine1,
      titleLine2: config.headlineLine2,
      description: config.subtitle,
      ctaLabel: SUMMER_2026_SALE_CTA_LABEL,
      action: {
        type: 'link',
        href: getSummer2026SaleCheckoutHref(resolved, promoCode),
      },
    };
  },
};
